// extracted by css-extract-rspack-plugin
export default {"message":"messagePopover-module__message___sAr_i","show":"messagePopover-module__show___ltWTK","abovePlayer":"messagePopover-module__abovePlayer___mbbZU"};